// A stable DOM marker (not tied to the CSS module or copy) so the shared PDF
// export helper (exportHelpers.ts waitForImages) can tell "still loading"
// apart from "failed" and "no url", and can tell an ImageElement-owned <img>
// from a foreign one (RECUR-28321).
export const IMAGE_STATE_ATTR = 'data-image-state';

export const ImageState = {
    PENDING: 'pending',
    ERROR: 'error',
    EMPTY: 'empty',
    RENDERED: 'rendered',
} as const;

export type ImageStateValue = (typeof ImageState)[keyof typeof ImageState];

// Matches the placeholder ImageElement renders while a docId is still
// resolving to a presigned URL.
export const PENDING_IMAGE_SELECTOR = `[${IMAGE_STATE_ATTR}="${ImageState.PENDING}"]`;

// Poll interval used by waitForImages while it waits for pending image
// markers to clear, and again for the broken-image swap (phase 3).
export const PENDING_IMAGE_POLL_MS = 100;
